import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authService } from "./userService";
import { jwtDecode } from "jwt-decode";


export const registerUser = createAsyncThunk("auth/register", async (userData, thunkApi) => {
    try {
        return await authService.register(userData);
    } catch (error) {
        return thunkApi.rejectWithValue(error);
    }
})

export const loginUser = createAsyncThunk("auth/login", async (userData, thunkApi) => {
    try {
        return await authService.login(userData);
    } catch (error) {
        return thunkApi.rejectWithValue(error);
    }
})



export const getUserDetails = createAsyncThunk(
    "auth/getUserById",
    async (userId, thunkApi) => {
        try {
            return await authService.getUserById(userId);
        } catch (error) {
            return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


const initialState = {
    user: null,
    userDetails: null,       // fetched user by ID

    isError: false,
    isLoading: false,
    isSuccess: false,
    message: ""
}


export const authSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(registerUser.pending, (state) => {
            state.isLoading = true;
        }).addCase(registerUser.fulfilled, (state, action) => {
            console.log("action.payload", action.payload);
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            // state.createdUser = action.payload;
            state.user = {
                token: action.payload.token,
                username: action.payload.user.username,
                userId: action.payload.user.id
            };
            state.message = "User Created Successfully ."

        }).addCase(registerUser.rejected, (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = true;
            state.message = action.error;
        }).addCase(loginUser.pending, (state) => {
            state.isLoading = true;
        }).addCase(loginUser.fulfilled, (state, action) => {

            // Decode the token
            const decoded = jwtDecode(action.payload.token);
            const { username, userId } = decoded;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.user = {
                token: action.payload.token,
                username,
                userId
            };
            state.message = "User Logged In Successfully ."
        }).addCase(loginUser.rejected, (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = true;
            state.message = action.error;
        })
            .addCase(getUserDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getUserDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.user = {
                    username: action.payload.username,
                    userId: action.payload._id
                };
                state.userDetails = action.payload;
                state.message = "User details fetched successfully";
            })
            .addCase(getUserDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || "Failed to fetch user details";
            })

    }
})

export const { logout } = authSlice.actions;


export default authSlice.reducer;